export class Resource<T> {
  private result?: T
  private status?: 'pending' | 'error' | 'success' = 'pending'
  private promise?: Promise<T>

  constructor(fn: () => Promise<T>) {
    this.promise = fn()
    this.promise.then(
      r => {
        this.status = 'success'
        this.result = r
      },
      e => {
        this.status = 'error'
        this.result = e
      },
    )
  }

  public read() {
    if (this.status === 'pending') {
      throw this.promise
    } else if (this.status === 'error') {
      throw this.result
    }

    if (this.result == null) {
      throw new Error('The resource data is empty!')
    }

    return this.result
  }
}
